import styled from 'styled-components'

export const IconContainer = styled.div`
    ${props =>
        `margin-top: ${
            typeof props.marginTop === 'number'
                ? props.marginTop + 'px'
                : 'auto'
        };`}
    ${props =>
        `margin-right: ${
            typeof props.marginRight === 'number'
                ? props.marginRight + 'px'
                : 'auto'
        };`}
    ${props =>
        `margin-bottom: ${
            typeof props.marginBottom === 'number'
                ? props.marginBottom + 'px'
                : 'auto'
        };`}
    ${props =>
        `margin-left: ${
            typeof props.marginLeft === 'number'
                ? props.marginLeft + 'px'
                : 'auto'
        };`}
`
